import { FormControl, InputLabel, MenuItem, Select, Skeleton } from "@mui/material";
import React, { useEffect } from "react";
import { userRoleType } from "src/constant";
import useGetDataFromSelect from "src/hooks/useGetDataFromSelect";
import useWarehouseStore from "src/stores/useWarehouseStore";

export default function SelectComp({ item, value, setValue, label, size = "small", userMe, ...props }) {
  const { data, isLoading } = useGetDataFromSelect(item?.path, item?.params);
  const { setCurrentWarehouse, currentWarehouse } = useWarehouseStore();
  const selectedValue = value ?? "";

  const handleChange = (e) => {
    setCurrentWarehouse({ currentWarehouse: e.target.value, isUpdated: true });
  };

  useEffect(() => {
    if (currentWarehouse?.isUpdated) {
      return;
    }
    if (userMe?.currentWarehouse?._id) {
      setCurrentWarehouse({ currentWarehouse: userMe?.currentWarehouse?._id, isUpdated: false });
    }
  }, [setCurrentWarehouse, userMe?.currentWarehouse?._id, currentWarehouse?.isUpdated]);

  useEffect(() => {
    if (!!currentWarehouse?.currentWarehouse) {
      setValue(currentWarehouse?.currentWarehouse);
    }
  }, [currentWarehouse, setValue]);

  return isLoading || !selectedValue ? (
    <Skeleton
      width="120px"
      height="56px"
    />
  ) : (
    <FormControl
      fullWidth
      size={size}
    >
      <InputLabel id="warehouse-select-label">{label}</InputLabel>

      <Select
        input={props.input}
        labelId="warehouse-select-label"
        id="warehouse-select"
        value={selectedValue}
        label={label}
        onChange={handleChange}
        disabled={props.disabled || userMe?.role?.code !== userRoleType.superAdmin.toLowerCase()}
      >
        {Array.isArray(data?.data) && data.data.length > 0 ? (
          data.data.map((warehouse) => (
            <MenuItem
              key={warehouse._id}
              value={warehouse._id}
            >
              {warehouse.name ?? warehouse.fullName}
            </MenuItem>
          ))
        ) : (
          <MenuItem
            disabled
            value=""
          >
            Không có dữ liệu
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
}
